import { WeatherPickingInfoLayer, WeatherPickingInfoObject, WeatherTooltip } from '@fe/weather';
import { convert } from 'html-to-text';
import React from 'react';
import ReactDOM, { Root } from 'react-dom/client';

export default function useConvertToText() {
    const clipboardRoot = React.useRef<Root | null>(null);
    const rootElement = React.useRef<HTMLDivElement | null>(null);

    React.useEffect(() => {
        let mounted = true;
        Promise.resolve().then(() => {
            // So that strict mode plays nicely
            if (!mounted) {
                return;
            }
            const element = document.createElement('div');
            element.style.display = 'none';
            document.body.appendChild(element);
            const root = ReactDOM.createRoot(element);
            rootElement.current = element;
            clipboardRoot.current = root;
        });

        return () => {
            mounted = false;
            const root = clipboardRoot.current;
            if (rootElement.current) {
                document.body.removeChild(rootElement.current);
            }
            self.setTimeout(() => {
                root?.unmount();
            }, 0);
            rootElement.current = null;
            clipboardRoot.current = null;
        };
    }, []);

    const convertToText = React.useCallback((layer: WeatherPickingInfoLayer, object: WeatherPickingInfoObject) => {
        if (!clipboardRoot.current || !rootElement.current) {
            return Promise.reject();
        }

        clipboardRoot.current.render(
            <WeatherTooltip layer={layer} object={object}/>
        );

        return new Promise<string>((resolve) => {
            self.setTimeout(() => {
                const text = convert(rootElement.current?.innerHTML ?? '').replaceAll(':\n', ': ');
                resolve(text);
            }, 0);
        });
    }, []);
    return convertToText;
}
